import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Text,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Divider,
  CircularProgress,
  useColorModeValue,
  HStack,
  VStack,
  Spacer,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
  useDisclosure,
  useToast,
  SimpleGrid,
  Switch,
  InputGroup,
  InputLeftElement,
  Icon,
  Grid,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Checkbox,
  GridItem,
  Image,
  Avatar,
  AvatarGroup,
} from '@chakra-ui/react';
import deviceLogo from '../../../assets/icons/ATBC IMAGE.png';
import moment from 'moment';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { MdSettings } from 'react-icons/md';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { AddIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import axiosInstance from 'axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import Swal from 'sweetalert2';
import DevelopmentTable from './tables/DevelopmentTable';
import ReactSelect from 'react-select';
import {
  FaBarcode,
  FaBox,
  FaBuilding,
  FaCalendarAlt,
  FaCalendarCheck,
  FaCalendarTimes,
  FaCertificate,
  FaCircle,
  FaClipboardCheck,
  FaClipboardList,
  FaCogs,
  FaHashtag,
  FaIndustry,
  FaNetworkWired,
  FaSatelliteDish,
  FaShieldAlt,
  FaSimCard,
  FaTachometerAlt,
  FaTag,
  FaTools,
  FaUserTie,
} from 'react-icons/fa';
import { getApiErrorMessage, notifyApiError } from 'utils/apiFeedback';
const Devices = () => {
  const createEmptyDeviceSetup = () => ({
    timestamp: new Date().toISOString(),
    mid: '',
    tankSensor: {
      c_status: '',
      type: '',
      brand: '',
      tankheight: '',
    },
    flowMeter: {
      c_status: '',
      type: '',
    },
    energyMeter: {
      c_status: '',
      type: '',
    },
    sim: {
      c_status: '',
      provider: '',
    },
  });

  const Token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  const canManageDevices = userRole === 'companyUser';
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isTankModalOpen,
    onOpen: onTankModalOpen,
    onClose: onTankModalClose,
  } = useDisclosure();
  const [device, setDevice] = useState([]);
  const [errors, setErrors] = useState([]);
  const [tankFormErrors, setTankFormErrors] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [productType, setProductType] = useState([]);
  const [company, setCompany] = useState([]);
  const [searchTerm, setSearchTerm] = useState({
    productName: '',
    productId: '',
    companyId: '',
  });
  const [addNewDevice, setAddNewDevice] = useState({
    productName: '',
    productId: '',
    devicePassword: '',
    dailyLimit: '',
    company: '',
    tank: '',
    license: { licenseKey: '', startDate: '', endDate: '' },
  });

  const [addNewTank, setAddNewTank] = useState({
    name: null,
    capacity: null,
  });

  const [editDevice, setEditDevice] = useState({
    productName: '',
    productId: '',
    devicePassword: '',
    dailyLimit: '',
    company: '',
    tankId: '',
    license: { licenseKey: '', startDate: '', endDate: '' },
  });
  const [editId, setEditId] = useState('');
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [editDeviceSetup, setEditDeviceSetup] = useState({
    timestamp: '',
    mid: '',
    tankSensor: {
      c_status: '',
      type: '',
      brand: '',
      tankheight: '',
    },
    flowMeter: {
      c_status: '',
      type: '',
    },
    energyMeter: {
      c_status: '',
      type: '',
    },
    sim: {
      c_status: '',
      provider: '',
    },
  });
  const [addDeviceSetup, setAddDeviceSetup] = useState(createEmptyDeviceSetup);
  const [editDeviceIdentifier, setEditDeviceIdentifier] =
    useState('deviceDetails');
  const pageBg = useColorModeValue('transparent', 'dark.900');
  const surfaceBg = useColorModeValue('white', 'dark.800');
  const insetBg = useColorModeValue('#F5F7FC', 'dark.700');
  const inputBg = useColorModeValue('white', 'dark.800');
  const modalBg = useColorModeValue('white', 'dark.800');
  const labelColor = useColorModeValue('gray.800', 'gray.300');
  const borderColor = useColorModeValue('gray.200', 'dark.600');
  const [companies, setCompanies] = useState([]);
  const [tanksData, setTanksData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const inputTextColor = useColorModeValue('black', 'gray.100');
  const inputPlaceholderColor = useColorModeValue('gray.500', 'gray.400');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');
  const hoverBorderColor = useColorModeValue('gray.400', 'gray.500');
  const selectedBg = useColorModeValue('#EDF2F7', 'dark.700');
  const focusedBg = useColorModeValue('#E2E8F0', 'dark.600');
  const headerBg = useColorModeValue(
    'linear-gradient(90deg, #4299E1 0%, #3182CE 50%, #2B6CB0 100%)',
    'linear-gradient(90deg, #2C5282 0%, #2A4365 50%, #1A365D 100%)',
  );
  const addmodalheaderBg = useColorModeValue(
    'linear-gradient(90deg,rgb(34, 84, 157) 0%,rgb(60, 129, 159) 50%,rgb(93, 153, 156) 100%)',
    'linear-gradient(90deg,rgb(39, 205, 230) 0%,rgb(81, 198, 224) 50%,rgb(136, 218, 236) 100%)',
  );

  const themeColor = '#1072BB';
  const accentColor = useColorModeValue(themeColor, 'aqua.300');
  const textPrimary = useColorModeValue('black', 'gray.100');
  const textMuted = useColorModeValue('gray.500', 'gray.400');
  const shadowValue = useColorModeValue(
    '0 4px 24px 0 rgba(41, 87, 122, 0.10)',
    '0 18px 48px rgba(0, 0, 0, 0.24)',
  );
  const configuredBadgeBg = useColorModeValue('green.500', 'green.400');
  const unconfiguredBadgeBg = useColorModeValue('orange.400', 'orange.500');
  const modalShellBg = useColorModeValue('rgba(0, 0, 0, 0.35)', 'blackAlpha.700');
  const modalSectionBg = useColorModeValue('white', 'dark.800');
  const modalSectionBorder = useColorModeValue('blue.100', 'dark.600');
  const modalHintColor = useColorModeValue('gray.500', 'gray.400');
  const modalInputBorder = useColorModeValue('gray.200', 'dark.600');
  const modalFieldBg = useColorModeValue('white', 'dark.700');
  const warningTextColor = useColorModeValue('red.500', 'red.300');
  const avatarColors = ['#E53E3E', '#DD6B20', '#38A169', '#3182CE', '#805AD5'];

  const companyOptions = [
    { value: '', label: 'Select Company' },
    ...company.map((company) => ({
      value: company._id,
      label: company.name,
    })),
  ];

  const fetchCompanies = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/company/list`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setCompanies(response?.data?.data?.data || []);
    } catch (error) {
      console.error('Error in getting company data', error);
    }
  };

  const fetchTanks = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}//tanks/fetchTanks`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setTanksData(response?.data?.data?.data || []);
    } catch (error) {
      console.error('Error in getting company data', error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    fetchTanks();
  }, []);

  useEffect(() => {
    getAllDevices();
  }, [page, searchTerm]);

  useEffect(() => {
    productTypes();
  }, [page]);

  useEffect(() => {
    getAllCompanies();
  }, [page]);

  useEffect(() => {
    if (canManageDevices && company.length === 1 && !addNewDevice.company) {
      setAddNewDevice((prevState) => ({
        ...prevState,
        company: company[0]._id,
      }));
    }
  }, [addNewDevice.company, canManageDevices, company]);

  const getAllDevices = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${baseUrl}/device?filter=${JSON.stringify(searchTerm)}&page=${page}`,
        { headers: { Authorization: `Bearer ${Token}` } },
      );
      const data = response.data.data;
      setDevice(data.data);
      setTotalPages(data.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to load devices');
    }
  };

  const checkValidity = (licenseExpiry) => {
    const expiryDate = moment(licenseExpiry.split('T')[0]).toDate();
    const currDate = new Date();
    if (currDate >= expiryDate) {
      return true;
    } else {
      return false;
    }
  };

  const productTypes = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/product`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setProductType(response.data.data.data);
    } catch (error) {
      console.error('Error in getting product data', error);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const getAllCompanies = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/company/list`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setCompany(response.data.data.data);
    } catch (error) {
      console.error('Error in getting company data', error);
    }
  };

  const handleAddChange = (e) => {
    const { name, value, type, checked } = e.target;
    const keys = name.split('.');

    setAddNewDevice((prevState) => {
      if (keys.length === 2) {
        return {
          ...prevState,
          [keys[0]]: {
            ...prevState[keys[0]],
            [keys[1]]: value,
          },
        };
      } else if (type === 'checkbox') {
        return {
          ...prevState,
          [name]: checked,
        };
      }
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const updateSetupField = (setSetupState, section, field, value) => {
    setSetupState((prev) => ({
      ...prev,
      timestamp: prev.timestamp || new Date().toISOString(),
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const hasDeviceSetupData = (setup) =>
    Boolean(
      setup?.tankSensor?.c_status ||
        setup?.tankSensor?.type ||
        setup?.tankSensor?.brand ||
        setup?.tankSensor?.tankheight ||
        setup?.flowMeter?.c_status ||
        setup?.flowMeter?.type ||
        setup?.energyMeter?.c_status ||
        setup?.energyMeter?.type ||
        setup?.sim?.c_status ||
        setup?.sim?.provider,
    );

  const buildDeviceSetupPayload = (setup, productId) => ({
    ...setup,
    mid: setup?.mid || productId || '',
    timestamp: setup?.timestamp || new Date().toISOString(),
  });

  const saveDeviceSetup = async (deviceId, setup, productId) => {
    if (!deviceId || !hasDeviceSetupData(setup)) return;

    await axiosInstance.put(
      `${baseUrl}/device/deviceSetup/?deviceID=${deviceId}`,
      buildDeviceSetupPayload(setup, productId),
      {
        headers: { Authorization: `Bearer ${Token}` },
      },
    );
  };

  const handleAddTankChange = (e) => {
    const { name, value } = e.target;

    setAddNewTank((prevState) => {
      if (name === 'tankName') {
        return {
          ...prevState,
          name: value,
        };
      } else if (name === 'capacity') {
        return {
          ...prevState,
          capacity: value,
        };
      }
    });
  };

  const saveNewtank = async () => {
    let temp = {};

    if (!addNewTank.name) temp.name = 'Tank name is required';
    if (!addNewTank.capacity) temp.capacity = 'Capacity is required';

    setTankFormErrors(temp);
    if (Object.keys(temp).length > 0) return;

    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/tanks/addTank`,
        addNewTank,
        {
          headers: { Authorization: `Bearer ${Token}` },
        },
      );
      if (response.data.data.code === 201) {
        toast({
          title: 'Tank added successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setAddNewTank({
          name: '',
          capacity: null,
        });
        fetchTanks();
      }
      onTankModalClose();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to add tank');
    }
  };

  const handleSaveNewDevice = async () => {
    let temp = {};

    if (!addNewDevice.productName) temp.name = 'Device name is required';
    if (!addNewDevice.productId) temp.productId = 'Product ID is required';
    if (!addNewDevice.devicePassword)
      temp.devicePassword = 'Device password is required';
    if (!addNewDevice.dailyLimit)
      temp.dailyLimit = 'Permissible daily limit is required';
    if (!addNewDevice.company) temp.company = 'Company is required';
    if (!addNewDevice.tank) temp.tank = 'Tank is required';
    if (!addNewDevice?.license?.licenseKey)
      temp.licenseKey = 'License key is required';
    if (!addNewDevice?.license?.startDate)
      temp.licenseStartDate = 'License start period is required';
    if (!addNewDevice?.license?.endDate)
      temp.licenseEndDate = 'License stop period is required';

    setErrors(temp);
    if (Object.keys(temp).length > 0) return;

    setLoading(true);
    try {
      const response = await axiosInstance.post(`${baseUrl}/device/add`, addNewDevice, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      const createdDevice =
        response?.data?.data?.data || response?.data?.data || null;
      const createdDeviceId = createdDevice?._id || createdDevice?.id;

      await saveDeviceSetup(
        createdDeviceId,
        addDeviceSetup,
        addNewDevice.productId,
      );

      onClose();
      setAddNewDevice({
        productName: '',
        productId: '',
        devicePassword: '',
        dailyLimit: '',
        company: '',
        tank: '',
        license: { licenseKey: '', startDate: '', endDate: '' },
      });
      setAddDeviceSetup(createEmptyDeviceSetup());
      toast({
        title: 'Device added successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      getAllDevices();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to add device');
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.put(
            `${baseUrl}/device/delete/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Token}`,
              },
            },
          );

          if (response.status === 200) {
            getAllDevices();
            Swal.fire('Deleted!', 'User has been deleted.', 'success');
          } else {
            Swal.fire('Error!', 'Failed to delete the user.', 'error');
          }
        } catch (error) {
          Swal.fire('Error!', getApiErrorMessage(error), 'error');
        }
      }
    });
  };

  const handleEdit = (device, event) => {
    event.stopPropagation();
    setEditId(device?._id);
    setEditDevice({
      productName: device?.borewellName || '',
      productId: device?.productId || '',
      company: device?.company?._id || '',
      tankId: device?.tankId || '',
      devicePassword: device?.devicePassword,
      dailyLimit: device?.limitPerDay,
      license: {
        licenseKey: device?.license?.licenseKey,
        startDate: device?.license?.licenseStartDate || '',
        endDate: device?.license?.licenseEndDate || '',
      },
    });
    setEditDeviceSetup({
      timestamp: new Date().toISOString(),
      mid: device?.deviceSetup?.mid || '',
      tankSensor: {
        c_status: device?.deviceSetup?.tankSensor?.c_status || '',
        type: device?.deviceSetup?.tankSensor?.type || '',
        brand: device?.deviceSetup?.tankSensor?.brand || '',
        tankheight: device?.deviceSetup?.tankSensor?.tankheight || '',
      },
      flowMeter: {
        c_status: device?.deviceSetup?.flowMeter?.c_status || '',
        type: device?.deviceSetup?.flowMeter?.type || '',
      },
      energyMeter: {
        c_status: device?.deviceSetup?.energyMeter?.c_status || '',
        type: device?.deviceSetup?.energyMeter?.type || '',
      },
      sim: {
        c_status: device?.deviceSetup?.sim?.c_status || '',
        provider: device?.deviceSetup?.sim?.provider || '',
      },
    });
    setEditDeviceIdentifier('deviceDetails');
    onEditOpen();
  };

  const handleTabChange = (index) => {
    if (index === 0) {
      setEditDeviceIdentifier('deviceDetails');
    } else if (index === 1) {
      setEditDeviceIdentifier('deviceSetup');
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      if (editDeviceIdentifier === 'deviceDetails') {
        await axiosInstance.put(`${baseUrl}/device/update/${editId}`, editDevice, {
          headers: { Authorization: `Bearer ${Token}` },
        });
      } else if (editDeviceIdentifier === 'deviceSetup') {
        await saveDeviceSetup(editId, editDeviceSetup, editDevice.productId);
      }

      setLoading(false);
      toast({
        title: 'Device updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onEditClose();
      getAllDevices();
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Update failed');
    }
  };

  const inputBackground = useColorModeValue('white', 'dark.800');
  const textColor = useColorModeValue('black', 'gray.100');

  const selectStyles = {
    container: (base) => ({
      ...base,
      width: '100%',
    }),
    control: (base, state) => ({
      ...base,
      minHeight: '48px',
      background: inputBackground,
      color: textColor,
      borderColor: state.isFocused ? themeColor : modalInputBorder,
      borderRadius: '8px',
      boxShadow: state.isFocused
        ? '0 0 0 1px rgba(16, 114, 187, 0.35)'
        : 'none',
      '&:hover': {
        borderColor: state.isFocused ? themeColor : hoverBorderColor,
      },
    }),
    valueContainer: (base) => ({
      ...base,
      minHeight: '46px',
      padding: '0 14px',
      flexWrap: 'nowrap',
    }),
    placeholder: (base) => ({
      ...base,
      color: inputPlaceholderColor,
      whiteSpace: 'nowrap',
    }),
    singleValue: (base) => ({
      ...base,
      color: textColor,
      whiteSpace: 'nowrap',
    }),
    input: (base) => ({
      ...base,
      color: textColor,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      minHeight: '46px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: modalInputBorder,
      marginBlock: '10px',
    }),
    option: (styles) => ({
      ...styles,
      color: 'black',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 20,
      borderRadius: '8px',
      overflow: 'hidden',
    }),
  };

  const handleCompanyChange = (selectedOption) => {
    setPage(1);
    setSearchTerm({ ...searchTerm, companyId: selectedOption.value });
  };

  const getAccessUserName = (user, index) => {
    if (typeof user === 'string') return `User ${index + 1}`;
    return user?.name || user?.username || user?.email || `User ${index + 1}`;
  };

  const renderAccessUsers = (users = []) => {
    const assignedUsers = Array.isArray(users) ? users : [];

    if (!assignedUsers.length) {
      return (
        <Text fontSize="sm" fontWeight="bold" color={textPrimary}>
          --
        </Text>
      );
    }

    return (
      <AvatarGroup size="xs" max={4} spacing="-2">
        {assignedUsers.map((user, index) => {
          const userName = getAccessUserName(user, index);

          return (
            <Avatar
              key={user?._id || user?.email || userName}
              name={userName}
              title={userName}
              bg={avatarColors[index % avatarColors.length]}
              color="white"
              border="2px solid"
              borderColor={surfaceBg}
            />
          );
        })}
      </AvatarGroup>
    );
  };

  const inputProps = {
    bg: modalFieldBg,
    color: inputTextColor,
    borderColor: modalInputBorder,
    borderRadius: '8px',
    _placeholder: { color: inputPlaceholderColor },
    _hover: { borderColor: hoverBorderColor },
    _focus: {
      borderColor: accentColor,
      boxShadow: '0 0 0 1px rgba(16, 114, 187, 0.35)',
    },
  };

  const renderModalSection = ({ title, subtitle, children, mb = 4 }) => (
    <Box
      bg={modalSectionBg}
      border="1px solid"
      borderColor={modalSectionBorder}
      borderRadius="8px"
      p={4}
      mb={mb}
    >
      <Text fontSize="lg" fontWeight="800" color={textPrimary}>
        {title}
      </Text>
      {subtitle && (
        <Text fontSize="xs" fontWeight="600" color={modalHintColor} mb={4}>
          {subtitle}
        </Text>
      )}
      {children}
    </Box>
  );

  const renderAddDeviceDetails = () =>
    renderModalSection({
      title: 'Device Details',
      subtitle: 'Enter your device details to connect and start monitoring & control.',
      children: (
        <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={4}>
          <FormControl isRequired isInvalid={errors.name}>
            <FormLabel fontSize="sm" color={labelColor}>
              Device Name
            </FormLabel>
            <Input
              name="productName"
              placeholder="PlantRoom-Controller-02"
              value={addNewDevice.productName}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.name}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.productId}>
            <FormLabel fontSize="sm" color={labelColor}>
              Device PID
            </FormLabel>
            <Input
              name="productId"
              placeholder="ATBC62351A"
              value={addNewDevice.productId}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.productId}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.devicePassword}>
            <FormLabel fontSize="sm" color={labelColor}>
              Password
            </FormLabel>
            <Input
              name="devicePassword"
              placeholder="demoPass@456"
              value={addNewDevice.devicePassword}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.devicePassword}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.licenseKey}>
            <FormLabel fontSize="sm" color={labelColor}>
              Device License Key
            </FormLabel>
            <Input
              name="license.licenseKey"
              placeholder="Enter license key"
              value={addNewDevice.license.licenseKey}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.licenseKey}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.company}>
            <FormLabel fontSize="sm" color={labelColor}>
              Company
            </FormLabel>
            <ReactSelect
              name="company"
              placeholder="Select company"
              value={
                company.find((comp) => comp._id === addNewDevice.company)
                  ? {
                      label: company.find(
                        (comp) => comp._id === addNewDevice.company,
                      ).name,
                      value: addNewDevice.company,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                handleAddChange({
                  target: {
                    name: 'company',
                    value: selectedOption ? selectedOption.value : '',
                  },
                })
              }
              options={[
                { label: 'None', value: '' },
                ...company.map((comp) => ({
                  label: comp.name,
                  value: comp._id,
                })),
              ]}
              styles={selectStyles}
            />
            <FormErrorMessage>{errors.company}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.dailyLimit}>
            <FormLabel fontSize="sm" color={labelColor}>
              Daily Limit
            </FormLabel>
            <Input
              name="dailyLimit"
              placeholder="Enter daily limit"
              value={addNewDevice.dailyLimit}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.dailyLimit}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.licenseStartDate}>
            <FormLabel fontSize="sm" color={labelColor}>
              License Start Date
            </FormLabel>
            <Input
              name="license.startDate"
              type="date"
              value={addNewDevice.license.startDate}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.licenseStartDate}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={errors.licenseEndDate}>
            <FormLabel fontSize="sm" color={labelColor}>
              License End Date
            </FormLabel>
            <Input
              name="license.endDate"
              type="date"
              value={addNewDevice.license.endDate}
              onChange={handleAddChange}
              {...inputProps}
            />
            <FormErrorMessage>{errors.licenseEndDate}</FormErrorMessage>
          </FormControl>

          <FormControl
            isRequired
            isInvalid={errors.tank}
            gridColumn={{ base: 'auto', md: 'span 2', xl: 'span 2' }}
          >
            <FormLabel fontSize="sm" color={labelColor}>
              Tanks
            </FormLabel>
            <Flex gap={3} align="center" flexWrap={{ base: 'wrap', md: 'nowrap' }}>
              <Box flex="1" minW={0}>
                <ReactSelect
                  name="tank"
                  placeholder="Select tank"
                  value={
                    tanksData.find((tank) => tank.id === addNewDevice.tank)
                      ? {
                          label: tanksData.find(
                            (tank) => tank.id === addNewDevice.tank,
                          ).name,
                          value: addNewDevice.tank,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleAddChange({
                      target: {
                        name: 'tank',
                        value: selectedOption ? selectedOption.value : '',
                      },
                    })
                  }
                  options={tanksData.map((tank) => ({
                    label: tank.name,
                    value: tank.id,
                  }))}
                  styles={selectStyles}
                />
              </Box>
              <Button
                aria-label="Add Tank"
                leftIcon={<AddIcon boxSize={2.5} />}
                bg="rgba(0, 106, 184, 1)"
                color="white"
                borderRadius="8px"
                onClick={onTankModalOpen}
                h="48px"
                minW="120px"
                flexShrink={0}
              >
                Tank
              </Button>
            </Flex>
            <FormErrorMessage>{errors.tank}</FormErrorMessage>
          </FormControl>
        </SimpleGrid>
      ),
    });

  const renderDeviceSetupFields = (setup, setSetupState) => (
    <>
      {renderModalSection({
        title: 'Tank Level Sensor',
        children: (
          <>
            <Checkbox
              mb={3}
              isChecked={setup.tankSensor.c_status === '1'}
              onChange={(e) =>
                updateSetupField(
                  setSetupState,
                  'tankSensor',
                  'c_status',
                  e.target.checked ? '1' : '0',
                )
              }
              colorScheme="blue"
            >
              Connected
            </Checkbox>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
              <FormControl>
                <FormLabel fontSize="sm" color={labelColor}>
                  Sensor Type
                </FormLabel>
                <Select
                  placeholder="Select sensor type"
                  value={setup?.tankSensor?.type || ''}
                  onChange={(e) =>
                    updateSetupField(
                      setSetupState,
                      'tankSensor',
                      'type',
                      e.target.value,
                    )
                  }
                  {...inputProps}
                >
                  <option value="HYDR">HYDR</option>
                  <option value="AQUA">AQUA</option>
                  <option value="WATER">WATER</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm" color={labelColor}>
                  Hydrostatic Brand
                </FormLabel>
                <Select
                  placeholder="Select brand"
                  value={setup?.tankSensor?.brand || ''}
                  onChange={(e) =>
                    updateSetupField(
                      setSetupState,
                      'tankSensor',
                      'brand',
                      e.target.value,
                    )
                  }
                  {...inputProps}
                >
                  <option value="HYDR">HYDR</option>
                  <option value="AQUA">AQUA</option>
                  <option value="WATER">WATER</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm" color={labelColor}>
                  Tank Height (m)
                </FormLabel>
                <Input
                  placeholder="10.0"
                  value={setup?.tankSensor?.tankheight || ''}
                  onChange={(e) =>
                    updateSetupField(
                      setSetupState,
                      'tankSensor',
                      'tankheight',
                      e.target.value,
                    )
                  }
                  {...inputProps}
                />
              </FormControl>
            </SimpleGrid>
          </>
        ),
      })}

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        {renderModalSection({
          title: 'Flow Meter Sensor',
          mb: 0,
          children: (
            <>
              <Checkbox
                mb={3}
                isChecked={setup.flowMeter.c_status === '1'}
                onChange={(e) =>
                  updateSetupField(
                    setSetupState,
                    'flowMeter',
                    'c_status',
                    e.target.checked ? '1' : '0',
                  )
                }
                colorScheme="blue"
              >
                Connected
              </Checkbox>
              <FormControl>
                <FormLabel fontSize="sm" color={labelColor}>
                  Flow Meter
                </FormLabel>
                <Select
                  placeholder="Select flow meter"
                  value={setup?.flowMeter?.type || ''}
                  onChange={(e) =>
                    updateSetupField(
                      setSetupState,
                      'flowMeter',
                      'type',
                      e.target.value,
                    )
                  }
                  {...inputProps}
                >
                  <option value="FM01">FM01</option>
                  <option value="FM02">FM02</option>
                </Select>
              </FormControl>
              <Text mt={2} fontSize="10px" fontWeight="700" color={warningTextColor}>
                Only MODBUS RS-485 flow meters are supported.
              </Text>
            </>
          ),
        })}

        {renderModalSection({
          title: 'Energy Meter',
          mb: 0,
          children: (
            <>
              <Checkbox
                mb={3}
                isChecked={setup.energyMeter.c_status === '1'}
                onChange={(e) =>
                  updateSetupField(
                    setSetupState,
                    'energyMeter',
                    'c_status',
                    e.target.checked ? '1' : '0',
                  )
                }
                colorScheme="blue"
              >
                Connected
              </Checkbox>
              <Text mt={12} fontSize="10px" fontWeight="700" color={warningTextColor}>
                Only MODBUS RS-485 flow meters are supported.
              </Text>
            </>
          ),
        })}

        {renderModalSection({
          title: 'SIM Card',
          mb: 0,
          children: (
            <>
              <Checkbox
                mb={3}
                isChecked={setup.sim.c_status === '1'}
                onChange={(e) =>
                  updateSetupField(
                    setSetupState,
                    'sim',
                    'c_status',
                    e.target.checked ? '1' : '0',
                  )
                }
                colorScheme="blue"
              >
                Connected
              </Checkbox>
              <FormControl>
                <FormLabel fontSize="sm" color={labelColor}>
                  SIM Card Provider
                </FormLabel>
                <Select
                  placeholder="Select provider"
                  value={setup.sim.provider}
                  onChange={(e) =>
                    updateSetupField(
                      setSetupState,
                      'sim',
                      'provider',
                      e.target.value,
                    )
                  }
                  {...inputProps}
                >
                  <option value="Airtel">Airtel</option>
                  <option value="Jio">Jio</option>
                  <option value="VI">VI</option>
                  <option value="BSNL">BSNL</option>
                </Select>
              </FormControl>
            </>
          ),
        })}
      </SimpleGrid>
    </>
  );

  return (
    <Box
      pt={{ base: '140px', md: '90px', xl: '90px', sm: '100px' }}
      bg={pageBg}
      color={textPrimary}
      minH="100vh"
      // px={{ base: '4', md: '8' }}
    >
      <Flex
        mb="5"
        // justifyContent={{ base: 'center', md: 'space-between' }}
        alignItems="center"
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ base: 4, md: 0 }}
      >
        <Flex>
          <Text fontSize="xl" fontWeight="bold" color={textPrimary}>
            Devices
          </Text>
        </Flex>
        <Flex
          justify="flex-end"
          align="center"
          gap={3}
          mb={{ base: 3, md: 0 }}
          flexWrap="wrap"
          width="100%"
        >
          {/* Devices Heading */}
          {/* <InputGroup
            width={{ base: '100%', md: 'auto' }}
            mb={{ base: 2, md: 0 }}
          >
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              borderRadius={20}
              placeholder="Search by name"
              value={searchTerm.productName}
              onChange={(e) =>
                setSearchTerm((prev) => ({
                  ...prev,
                  productName: e.target.value,
                }))
              }
              leftIcon={<SearchIcon />}
              bg={useColorModeValue('white', 'gray.700')}
              color={useColorModeValue('black', 'white')}
              _placeholder={{
                color: useColorModeValue('gray.500', 'gray.400'),
              }}
            />
          </InputGroup> */}
          <InputGroup width={{ base: '100%', md: 'auto' }} marginRight={2}>
            <InputLeftElement pointerEvents="none">
              <SearchIcon color={textMuted} />
            </InputLeftElement>
            <Input
              borderRadius={10}
              placeholder="Search Device"
              value={searchTerm.productId}
              onChange={(e) =>
                setSearchTerm((prev) => ({
                  ...prev,
                  productId: e.target.value,
                }))
              }
              leftIcon={<SearchIcon />}
              bg={inputBg}
              // bg="white"
              color={inputTextColor}
              borderColor={borderColor}
              _placeholder={{
                color: inputPlaceholderColor,
              }}
            />
          </InputGroup>
          {/* <ReactSelect
            options={companyOptions}
            value={companyOptions.find(
              (option) => option.value === selectedCompany,
            )}
            onChange={(selectedOption) => {
              handleCompanyChange(selectedOption);
            }}
            placeholder="Select Company"
            isSearchable
            styles={{
              container: (base) => ({
                ...base,
                width: ['100%', '100%', '40%'],
                bgColor: 'gray.100',
                zIndex: 999,
              }),
              control: (base) => ({
                ...base,
                backgroundColor: inputBg,
                color: inputTextColor,
                borderColor: borderColor,
                borderRadius: '20px',
                boxShadow: 'none',
                '&:hover': {
                  borderColor: hoverBorderColor,
                },
                zIndex: 5,
              }),
              singleValue: (base) => ({
                ...base,
                color: inputTextColor,
              }),
              input: (base) => ({
                ...base,
                color: inputTextColor,
              }),
              placeholder: (base) => ({
                ...base,
                color: placeholderColor,
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: inputBg,
                maxHeight: '200px',
                // overflowY: 'auto',
              }),
              menuList: (base) => ({
                ...base,
                backgroundColor: inputBg,
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected
                  ? selectedBg
                  : isFocused
                  ? focusedBg
                  : 'transparent',
                color: inputTextColor,
                '&:hover': {
                  backgroundColor: selectedBg,
                },
              }),
            }}
          /> */}
        </Flex>
        {canManageDevices && (
          <Button
            onClick={onOpen}
            bg="rgba(0, 106, 184, 1)"
            color="white"
            leftIcon={<AddIcon boxSize={2.5} />}
            rounded="base"
            width={{ base: '100%', md: 'auto', lg: '10rem' }}
            fontSize="14px"
          >
            Add Device
          </Button>
        )}
      </Flex>

      {/* <DevelopmentTable
        tableData={device}
        handleEditUser={(device, e) => handleEdit(device, e)}
        handleDeleteUser={(id, e) => handleDelete(id, e)}
        handlePageChange={handlePageChange}
        page={page}
        totalPages={totalPages}
        loading={loading}
      /> */}

      <Box
        bg={surfaceBg}
        border="1px solid"
        borderColor={borderColor}
        p={4}
        rounded="xl"
        boxShadow={shadowValue}
      >
        {loading ? (
          <Flex justifyContent="center" py={10}>
            <CircularProgress isIndeterminate color="blue.500" />
          </Flex>
        ) : (
          <Grid templateColumns="1fr">
            {device && device.length > 0 ? (
              device.map((dev) => {
                const isExpired = checkValidity(dev?.license?.licenseEndDate);
                // --- Device-specific variables ---
                const isConfigured = dev?.deviceSetup;
                const configButtonText = isConfigured
                  ? 'Configured'
                  : 'Not configured';
                const configBadgeBg = isConfigured
                  ? configuredBadgeBg
                  : unconfiguredBadgeBg;

                const sensorData = [
                  {
                    label: 'Tank Level Sensor',
                    value: dev?.deviceSetup
                      ? dev?.deviceSetup?.tankSensor?.c_status === '1'
                        ? 'Connected'
                        : 'Not connected'
                      : '--',
                  },
                  {
                    label: 'Flow Meter Sensor',
                    value: dev?.deviceSetup
                      ? dev?.deviceSetup?.flowMeter?.c_status === '1'
                        ? 'Connected'
                        : 'Not connected'
                      : '--',
                  },
                  {
                    label: 'Energy Meter',
                    value: dev?.deviceSetup
                      ? dev?.deviceSetup?.energyMeter?.c_status === '1'
                        ? 'Connected'
                        : 'Not connected'
                      : '--',
                  },
                  {
                    label: 'SIM Card',
                    value: dev?.deviceSetup ? 'Airtel' : '--',
                  },
                  {
                    label: 'SIM Card Provider',
                    value: dev?.deviceSetup ? 'Aquasense' : '--',
                  },
                ];

                return (
                  <Box
                    key={dev.id}
                    p={4}
                    shadow="sm"
                    borderWidth="1px"
                    borderRadius="lg"
                    mb={4}
                    borderColor={borderColor}
                  >
                    {/* TOP SECTION: Device Title, License Dates, and Configure Button/Menu */}
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      mb={4}
                    >
                      <HStack>
                        {/* <MdSettings size="24px" color={statusColor} />
                         */}
                        <Image
                          src={deviceLogo}
                          alt="Device Logo"
                          boxSize="48px" // same size as your MdSettings icon
                          objectFit="contain"
                        />
                        <VStack align="flex-start" spacing={0}>
                          <Text
                            fontWeight="semibold"
                            fontSize="lg"
                            color={accentColor}
                          >
                            {dev.borewellName}
                          </Text>
                          <Text
                            fontSize="sm"
                            color={textMuted}
                            fontWeight="medium"
                          >
                            {dev.productId}
                          </Text>
                        </VStack>
                      </HStack>

                      <HStack spacing={20}>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                          display={{ base: 'none', md: 'block' }}
                        >
                          License Start Date:{' '}
                          <Text
                            as="span"
                            fontWeight="medium"
                            color={textPrimary}
                            fontSize="sm"
                          >
                            {moment(
                              dev?.license?.licenseStartDate.split('T')[0],
                            ).format('DD MMMM YYYY')}
                          </Text>
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                          display={{ base: 'none', md: 'block' }}
                        >
                          License End Date:{' '}
                          <Text
                            as="span"
                            fontWeight="medium"
                            color={isExpired ? 'red.500' : textPrimary}
                            fontSize="sm"
                          >
                            {moment(
                              dev?.license?.licenseEndDate.split('T')[0],
                            ).format('DD MMMM YYYY')}
                          </Text>
                        </Text>

                        <Text
                          bg={configBadgeBg}
                          color="white"
                          fontSize="sm"
                          fontWeight="700"
                          minW="118px"
                          textAlign="center"
                          rounded="md"
                          px={3}
                          py={2}
                        >
                          {configButtonText}
                        </Text>

                        {canManageDevices && (
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Actions"
                              icon={<BsThreeDotsVertical />}
                              variant="ghost"
                              size="sm"
                            />
                            <MenuList>
                              <MenuItem
                                icon={<FiEdit />}
                                onClick={(e) => handleEdit(dev, e)}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                icon={<FiTrash2 />}
                                onClick={(e) => handleDelete(dev._id, e)}
                              >
                                Delete
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        )}
                      </HStack>
                    </Flex>

                    {/* <Divider orientation="horizontal" mb={4} /> */}

                    {/* BOTTOM SECTION: Sensor and Access Details */}
                    <Flex
                      justifyContent="space-between"
                      flexWrap="wrap"
                      bg={insetBg}
                      minH="106px"
                      padding="20px"
                      alignItems="center"
                      borderRadius="8px"
                      gap={4}
                    >
                      {sensorData.map((item, index) => (
                        <VStack
                          key={index}
                          minW={{ base: '42%', md: '15%' }}
                          align="center"
                          spacing={0.5}
                        >
                          <Text
                            fontSize="sm"
                            color={accentColor}
                            fontWeight="medium"
                            textTransform="capitalize"
                          >
                            {item.label}
                          </Text>
                          <Text
                            fontSize="sm"
                            fontWeight="bold"
                            color={textPrimary}
                          >
                            {item.value}
                          </Text>
                        </VStack>
                      ))}

                      <VStack
                        minW={{ base: '42%', md: '12%' }}
                        align="center"
                        spacing={0.5}
                      >
                        <Text
                          fontSize="sm"
                          color={accentColor}
                          fontWeight="medium"
                          textTransform="capitalize"
                        >
                          Access
                        </Text>
                        {renderAccessUsers(dev.assignedUsers)}
                      </VStack>
                    </Flex>
                  </Box>
                );
              })
            ) : (
              <Text textAlign="center" py={10} color={textMuted}>
                No devices found.
              </Text>
            )}
          </Grid>
        )}

        {/* Pagination */}
        {/* {totalPages > 1 && renderPagination()} */}
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay bg={modalShellBg} />
        <ModalContent
          maxWidth="980px"
          bg={modalBg}
          borderRadius="14px"
          overflow="hidden"
          style={{
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Box
            bg={addmodalheaderBg}
            py={2}
            px={4}
            textAlign="center"
            roundedTop="xl"
          >
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              Add New Device
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>

          <ModalBody
            overflowY="auto"
            px={6}
            py={4}
            bg={modalSectionBg}
          >
            {renderAddDeviceDetails()}
            {renderDeviceSetupFields(addDeviceSetup, setAddDeviceSetup)}

            <Box mb={8} display="none">
              <Flex alignItems="center" mb={4}>
                <Icon as={FaCogs} w={6} h={6} color="blue.500" mr={2} />
                <Text fontSize="lg" fontWeight="semibold">
                  Device Details
                </Text>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4">
                <FormControl isRequired isInvalid={errors.name}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Device Name
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaTag} />
                    </InputLeftElement>
                    <Input
                      name="productName"
                      placeholder="Enter device name"
                      value={addNewDevice.productName}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.name}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.productId}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Device PID
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="productId"
                      placeholder="Enter product ID"
                      value={addNewDevice.productId}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.productId}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.devicePassword}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Password
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="devicePassword"
                      placeholder="Enter password"
                      value={addNewDevice.password}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.devicePassword}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.licenseKey}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Device License Key
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="license.licenseKey"
                      placeholder="Enter license key"
                      value={addNewDevice.license.licenseKey}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.licenseKey}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.licenseStartDate}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    License Start Date
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaCalendarTimes} />
                    </InputLeftElement>
                    <Input
                      name="license.startDate"
                      type="date"
                      value={addNewDevice.license.startDate}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.licenseStartDate}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.licenseEndDate}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    License End Date
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaCalendarTimes} />
                    </InputLeftElement>
                    <Input
                      name="license.endDate"
                      type="date"
                      value={addNewDevice.license.endDate}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.licenseEndDate}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.dailyLimit}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Permissible Daily Limit
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="dailyLimit"
                      placeholder="Enter daily limit"
                      value={addNewDevice.dailyLimit}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{errors.dailyLimit}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.company}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Company
                  </FormLabel>
                  <ReactSelect
                    name="company"
                    placeholder="Select company"
                    value={
                      company.find((comp) => comp._id === addNewDevice.company)
                        ? {
                            label: company.find(
                              (comp) => comp._id === addNewDevice.company,
                            ).name,
                            value: addNewDevice.company,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleAddChange({
                        target: {
                          name: 'company',
                          value: selectedOption ? selectedOption.value : '',
                        },
                      })
                    }
                    options={[
                      { label: 'None', value: '' },
                      ...company.map((comp) => ({
                        label: comp.name,
                        value: comp._id,
                      })),
                    ]}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.800', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{errors.company}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={errors.tank}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Tanks
                  </FormLabel>
                  <ReactSelect
                    name="tank"
                    placeholder="Select tank"
                    value={
                      tanksData.find((tank) => tank.id === addNewDevice.tank)
                        ? {
                            label: tanksData.find(
                              (tank) => tank.id === addNewDevice.tank,
                            ).name,
                            value: addNewDevice.tank,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleAddChange({
                        target: {
                          name: 'tank',
                          value: selectedOption ? selectedOption.value : '',
                        },
                      })
                    }
                    options={[
                      // { label: 'None', value: '' },
                      ...tanksData.map((tank) => ({
                        label: tank.name,
                        value: tank.id,
                      })),
                    ]}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.800', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{errors.tank}</FormErrorMessage>
                </FormControl>
                <FormControl>
                  <Button
                    marginTop="27px"
                    bg="rgba(0, 106, 184, 1)"
                    color="white"
                    onClick={() => {
                      onTankModalOpen(true);
                    }}
                    isLoading={loading}
                    borderRadius="md"
                    shadow="sm"
                    _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
                  >
                    Add Tank
                  </Button>
                </FormControl>
              </SimpleGrid>
            </Box>
          </ModalBody>

          <ModalFooter
            bg={modalSectionBg}
            py={4}
            px={6}
            justifyContent="flex-start"
          >
            <Button
              variant="ghost"
              colorScheme="red"
              fontWeight="medium"
              onClick={onClose}
              borderRadius="md"
              display="none"
              _hover={{ bg: useColorModeValue('red.50', 'red.900') }}
            >
              Cancel
            </Button>
            <Button
              bg="rgba(0, 106, 184, 1)"
              color="white"
              onClick={handleSaveNewDevice}
              isLoading={loading}
              borderRadius="md"
              minW="220px"
              shadow="sm"
              _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isTankModalOpen} onClose={onTankModalClose} size="lg">
        <ModalOverlay />
        <ModalContent
          maxWidth="900px"
          bg={modalBg}
          roundedTop="xl"
          style={{
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Box
            bg={addmodalheaderBg}
            py={2}
            px={4}
            textAlign="center"
            roundedTop="xl"
          >
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              Add New Tank
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>

          <ModalBody
            overflowY="auto"
            px={6}
            py={4}
            style={{
              backgroundColor: useColorModeValue('gray.50', 'gray.800'),
            }}
          >
            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon as={FaCogs} w={6} h={6} color="blue.500" mr={2} />
                <Text fontSize="lg" fontWeight="semibold">
                  Tank Details
                </Text>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4">
                <FormControl isRequired isInvalid={tankFormErrors.name}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Tank Name
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaTag} />
                    </InputLeftElement>
                    <Input
                      name="tankName"
                      placeholder="Enter tank name"
                      value={addNewTank.name}
                      onChange={handleAddTankChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{tankFormErrors.name}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={tankFormErrors.capacity}>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Tank Capacity
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      type="number"
                      name="capacity"
                      placeholder="Enter tank capacity"
                      value={addNewTank.capacity}
                      onChange={handleAddTankChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{tankFormErrors.capacity}</FormErrorMessage>
                </FormControl>
              </SimpleGrid>
            </Box>
          </ModalBody>

          <ModalFooter
            bg={useColorModeValue('gray.50', 'gray.800')}
            borderTop="1px solid"
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            py={5}
            px={6}
            justifyContent="space-between"
            roundedBottom="xl"
          >
            <Button
              variant="ghost"
              colorScheme="red"
              fontWeight="medium"
              onClick={onTankModalClose}
              borderRadius="md"
              _hover={{ bg: useColorModeValue('red.50', 'red.900') }}
            >
              Cancel
            </Button>
            <Button
              bg="rgba(0, 106, 184, 1)"
              color="white"
              onClick={saveNewtank}
              isLoading={loading}
              borderRadius="md"
              shadow="sm"
              _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* <Modal isOpen={isEditOpen} onClose={onEditClose} size="md">
        <ModalOverlay />
        <ModalContent
          maxWidth="900px"
          bg={modalBg}
          roundedTop="xl"
          style={{
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Box
            bg={addmodalheaderBg}
            py={2}
            px={4}
            textAlign="center"
            roundedTop="xl"
          >
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={EditIcon} mr={2} />
              Edit Device
            </ModalHeader>
            <ModalCloseButton />
          </Box>
          <ModalBody
            overflowY="auto"
            px={6}
            py={4}
            style={{
              backgroundColor: useColorModeValue('gray.50', 'gray.800'),
            }}
          >
            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon as={FaCogs} w={6} h={6} color="blue.500" mr={2} />
                <Text fontSize="lg" fontWeight="semibold">
                  Device Details
                </Text>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4">
                <FormControl isRequired>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Device Name
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaTag} />
                    </InputLeftElement>
                    <Input
                      name="productName"
                      value={editDevice.productName}
                      onChange={(e) =>
                        setEditDevice({
                          ...editDevice,
                          productName: e.target.value,
                        })
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Device PID
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="productId"
                      value={editDevice.productId}
                      onChange={(e) =>
                        setEditDevice({
                          ...editDevice,
                          productId: e.target.value,
                        })
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Password
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="devicePassword"
                      value={editDevice.devicePassword}
                      onChange={(e) =>
                        setEditDevice({
                          ...editDevice,
                          devicePassword: e.target.value,
                        })
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Device License Key
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="licenseKey"
                      value={editDevice.license.licenseKey}
                      onChange={(e) =>
                        setEditDevice((prev) => ({
                          ...prev,
                          license: {
                            ...prev.license,
                            licenseKey: e.target.value,
                          },
                        }))
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm" color={labelColor}>
                    License Start Date
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaCalendarTimes} />
                    </InputLeftElement>
                    <Input
                      name="license.startDate"
                      type="date"
                      value={
                        editDevice?.license?.startDate
                          ? new Date(editDevice.license.startDate)
                              .toISOString()
                              .split('T')[0]
                          : ''
                      }
                      onChange={(e) =>
                        setEditDevice((prev) => ({
                          ...prev,
                          license: {
                            ...prev.license,
                            startDate: e.target.value,
                          },
                        }))
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm" color={labelColor}>
                    License End Date
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaCalendarTimes} />
                    </InputLeftElement>
                    <Input
                      name="license.endDate"
                      type="date"
                      value={
                        editDevice?.license?.endDate
                          ? new Date(editDevice.license.endDate)
                              .toISOString()
                              .split('T')[0]
                          : ''
                      }
                      onChange={(e) =>
                        setEditDevice((prev) => ({
                          ...prev,
                          license: {
                            ...prev.license,
                            endDate: e.target.value,
                          },
                        }))
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Permissible Daily Limit
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBarcode} />
                    </InputLeftElement>
                    <Input
                      name="dailyLimit"
                      placeholder="Enter daily limit"
                      value={editDevice.dailyLimit}
                      onChange={(e) =>
                        setEditDevice({
                          ...editDevice,
                          dailyLimit: e.target.value,
                        })
                      }
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>
       
                <FormControl>
                  <FormLabel fontSize="sm" color={labelColor}>
                    Company
                  </FormLabel>
                  <ReactSelect
                    name="company"
                    placeholder="Select company"
                    value={
                      company.find((comp) => comp._id === editDevice.company)
                        ? {
                            label: company.find(
                              (comp) => comp._id === editDevice.company,
                            ).name,
                            value: editDevice.company,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      setEditDevice((prev) => ({
                        ...prev,
                        company: selectedOption ? selectedOption.value : '',
                      }))
                    }
                    options={[
                      { label: 'None', value: '' },
                      ...company.map((comp) => ({
                        label: comp.name,
                        value: comp._id,
                      })),
                    ]}
                    styles={selectStyles}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.800', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                </FormControl>
              </SimpleGrid>
            </Box>
          </ModalBody>
          <ModalFooter
            bg={modalSectionBg}
            py={4}
            px={6}
            justifyContent="flex-start"
          >
            <Button
              variant="ghost"
              colorScheme="red"
              fontWeight="medium"
              borderRadius="md"
              display="none"
              _hover={{ bg: useColorModeValue('red.50', 'red.900') }}
              onClick={onEditClose}
            >
              Cancel
            </Button>
            <Button
              bg="rgba(0, 106, 184, 1)"
              color="white"
              borderRadius="md"
              minW="220px"
              shadow="sm"
              _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
              onClick={handleSave}
              isLoading={loading}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}
      <Modal isOpen={isEditOpen} onClose={onEditClose} size="md">
        <ModalOverlay bg={modalShellBg} />
        <ModalContent
          maxWidth="980px"
          bg={modalBg}
          borderRadius="14px"
          overflow="hidden"
          style={{
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Box
            bg={addmodalheaderBg}
            py={2}
            px={4}
            textAlign="center"
            roundedTop="xl"
          >
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              Edit Device
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>

          <ModalBody
            overflowY="auto"
            px={6}
            py={4}
            bg={modalSectionBg}
          >
            {/* Tabs Section */}
            <Tabs
              onChange={handleTabChange}
              variant="enclosed"
              colorScheme="blue"
              isFitted
            >
              <TabList mb="1em">
                <Tab fontWeight="semibold">Device Details</Tab>
                <Tab fontWeight="semibold">Device Configuration</Tab>
              </TabList>

              <TabPanels>
                {/* -------------------- DEVICE DETAILS TAB -------------------- */}
                <TabPanel>
                  <Box mb={8}>
                    {/* <Flex alignItems="center" mb={4}>
                      <Icon as={FaCogs} w={6} h={6} color="blue.500" mr={2} />
                      <Text fontSize="lg" fontWeight="semibold">
                        Device Details
                      </Text>
                    </Flex> */}

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4">
                      <FormControl isRequired>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Device Name
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaTag} />
                          </InputLeftElement>
                          <Input
                            name="productName"
                            value={editDevice.productName}
                            onChange={(e) =>
                              setEditDevice({
                                ...editDevice,
                                productName: e.target.value,
                              })
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Device PID
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaBarcode} />
                          </InputLeftElement>
                          <Input
                            name="productId"
                            value={editDevice.productId}
                            onChange={(e) =>
                              setEditDevice({
                                ...editDevice,
                                productId: e.target.value,
                              })
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Password
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaBarcode} />
                          </InputLeftElement>
                          <Input
                            name="devicePassword"
                            value={editDevice.devicePassword}
                            onChange={(e) =>
                              setEditDevice({
                                ...editDevice,
                                devicePassword: e.target.value,
                              })
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Device License Key
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaBarcode} />
                          </InputLeftElement>
                          <Input
                            name="licenseKey"
                            value={editDevice.license.licenseKey}
                            onChange={(e) =>
                              setEditDevice((prev) => ({
                                ...prev,
                                license: {
                                  ...prev.license,
                                  licenseKey: e.target.value,
                                },
                              }))
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl>
                        <FormLabel fontSize="sm" color={labelColor}>
                          License Start Date
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaCalendarTimes} />
                          </InputLeftElement>
                          <Input
                            name="license.startDate"
                            type="date"
                            value={
                              editDevice?.license?.startDate
                                ? new Date(editDevice.license.startDate)
                                    .toISOString()
                                    .split('T')[0]
                                : ''
                            }
                            onChange={(e) =>
                              setEditDevice((prev) => ({
                                ...prev,
                                license: {
                                  ...prev.license,
                                  startDate: e.target.value,
                                },
                              }))
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl>
                        <FormLabel fontSize="sm" color={labelColor}>
                          License End Date
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaCalendarTimes} />
                          </InputLeftElement>
                          <Input
                            name="license.endDate"
                            type="date"
                            value={
                              editDevice?.license?.endDate
                                ? new Date(editDevice.license.endDate)
                                    .toISOString()
                                    .split('T')[0]
                                : ''
                            }
                            onChange={(e) =>
                              setEditDevice((prev) => ({
                                ...prev,
                                license: {
                                  ...prev.license,
                                  endDate: e.target.value,
                                },
                              }))
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl isRequired>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Permissible Daily Limit
                        </FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaBarcode} />
                          </InputLeftElement>
                          <Input
                            name="dailyLimit"
                            placeholder="Enter daily limit"
                            value={editDevice.dailyLimit}
                            onChange={(e) =>
                              setEditDevice({
                                ...editDevice,
                                dailyLimit: e.target.value,
                              })
                            }
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('gray.800', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Company
                        </FormLabel>
                        <ReactSelect
                          name="company"
                          placeholder="Select company"
                          value={
                            company.find(
                              (comp) => comp._id === editDevice.company,
                            )
                              ? {
                                  label: company.find(
                                    (comp) => comp._id === editDevice.company,
                                  ).name,
                                  value: editDevice.company,
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            setEditDevice((prev) => ({
                              ...prev,
                              company: selectedOption
                                ? selectedOption.value
                                : '',
                            }))
                          }
                          options={[
                            { label: 'None', value: '' },
                            ...company.map((comp) => ({
                              label: comp.name,
                              value: comp._id,
                            })),
                          ]}
                          styles={selectStyles}
                        />
                      </FormControl>

                      <FormControl>
                        <FormLabel fontSize="sm" color={labelColor}>
                          Tanks
                        </FormLabel>
                        <ReactSelect
                          name="tank"
                          placeholder="Select tank"
                          value={
                            tanksData.find(
                              (tank) => tank.id === editDevice.tankId,
                            )
                              ? {
                                  label: tanksData.find(
                                    (tank) => tank.id === editDevice.tankId,
                                  ).name,
                                  value: editDevice.tankId,
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            setEditDevice((prev) => ({
                              ...prev,
                              tankId: selectedOption
                                ? selectedOption.value
                                : '',
                            }))
                          }
                          options={[
                            { label: 'None', value: '' },
                            ...tanksData.map((tank) => ({
                              label: tank.name,
                              value: tank.id,
                            })),
                          ]}
                          styles={selectStyles}
                        />
                      </FormControl>
                    </SimpleGrid>
                  </Box>
                </TabPanel>

                {/* -------------------- DEVICE CONFIGURATION TAB -------------------- */}
                <TabPanel>
                  <Box
                    p={4}
                    borderWidth="1px"
                    borderRadius="lg"
                    borderColor="gray.300"
                  >
                    {/* Tank Level Sensor Section */}
                    <Box borderColor="blue.200" p={2} mb={4}>
                      <Flex
                        align="flex-start"
                        justify="space-between"
                        flexDirection="column"
                        mb={2}
                      >
                        <Text fontWeight="semibold" fontSize="md">
                          Tank Level Sensor
                        </Text>
                        <Checkbox
                          isChecked={
                            editDeviceSetup.tankSensor.c_status === '1'
                          }
                          onChange={(e) =>
                            setEditDeviceSetup((prev) => ({
                              ...prev,
                              tankSensor: {
                                ...prev.tankSensor,
                                c_status: e.target.checked ? '1' : '0',
                              },
                            }))
                          }
                          colorScheme="blue"
                        >
                          Connected
                        </Checkbox>
                      </Flex>

                      <Grid
                        templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
                        gap={4}
                      >
                        <GridItem>
                          <Text fontSize="sm" color="gray.600" mb={1}>
                            Sensor Type
                          </Text>
                          <Select
                            placeholder="Select sensor type"
                            value={editDeviceSetup?.tankSensor?.type || ''}
                            onChange={(e) =>
                              setEditDeviceSetup((prev) => ({
                                ...prev,
                                tankSensor: {
                                  ...prev.tankSensor,
                                  type: e.target.value,
                                },
                              }))
                            }
                          >
                            <option value="HYDR">HYDR</option>
                            <option value="AQUA">AQUA</option>
                            <option value="WATER">WATER</option>
                          </Select>
                        </GridItem>

                        <GridItem>
                          <Text fontSize="sm" color="gray.600" mb={1}>
                            Hydrostatic Brand
                          </Text>
                          <Select
                            placeholder="Select sensor brand"
                            value={editDeviceSetup?.tankSensor?.brand || ''}
                            onChange={(e) =>
                              setEditDeviceSetup((prev) => ({
                                ...prev,
                                tankSensor: {
                                  ...prev.tankSensor,
                                  brand: e.target.value,
                                },
                              }))
                            }
                          >
                            <option value="HYDR">HYDR</option>
                            <option value="AQUA">AQUA</option>
                            <option value="WATER">WATER</option>
                          </Select>
                        </GridItem>

                        <GridItem>
                          <Text fontSize="sm" color="gray.600" mb={1}>
                            Tank Height (m)
                          </Text>
                          <Input
                            onChange={(e) =>
                              setEditDeviceSetup((prev) => ({
                                ...prev,
                                tankSensor: {
                                  ...prev.tankSensor,
                                  tankheight: e.target.value,
                                },
                              }))
                            }
                            placeholder="Enter height"
                            value={editDeviceSetup.tankSensor.tankheight}
                          />
                        </GridItem>
                      </Grid>
                    </Box>

                    {/* Flow Meter, Energy Meter, SIM Card Section */}
                    <Grid
                      templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
                      gap={4}
                    >
                      {/* Flow Meter Sensor */}
                      <Box
                        border="1px dashed"
                        borderColor="blue.200"
                        borderRadius="md"
                        p={4}
                      >
                        <Flex
                          align="center"
                          flexDirection="column"
                          alignItems="flex-start"
                          mb={2}
                        >
                          <Text fontWeight="semibold" fontSize="md">
                            Flow Meter Sensor
                          </Text>
                          <Checkbox
                            isChecked={
                              editDeviceSetup.flowMeter.c_status === '1'
                            }
                            onChange={(e) =>
                              setEditDeviceSetup((prev) => ({
                                ...prev,
                                flowMeter: {
                                  ...prev.flowMeter,
                                  c_status: e.target.checked ? '1' : '0',
                                },
                              }))
                            }
                            colorScheme="blue"
                          >
                            Connected
                          </Checkbox>
                        </Flex>

                        <Text fontSize="sm" color="gray.600" mb={1}>
                          Flow Meter
                        </Text>
                        <Select
                          placeholder="Select flow meter"
                          value={editDeviceSetup?.flowMeter?.type || ''}
                          onChange={(e) =>
                            setEditDeviceSetup((prev) => ({
                              ...prev,
                              flowMeter: {
                                ...prev.flowMeter,
                                type: e.target.value,
                              },
                            }))
                          }
                        >
                          <option value="FM01">FM01</option>
                          <option value="FM02">FM02</option>
                        </Select>
                      </Box>

                      {/* Energy Meter */}
                      <Box
                        border="1px dashed"
                        borderColor="blue.200"
                        borderRadius="md"
                        p={4}
                      >
                        <Flex
                          align="center"
                          flexDirection="column"
                          alignItems="flex-start"
                          mb={2}
                        >
                          <Text fontWeight="semibold" fontSize="md">
                            Energy Meter
                          </Text>
                          <Checkbox
                            isChecked={
                              editDeviceSetup.energyMeter.c_status === '1'
                            }
                            onChange={(e) =>
                              setEditDeviceSetup((prev) => ({
                                ...prev,
                                energyMeter: {
                                  ...prev.energyMeter,
                                  c_status: e.target.checked ? '1' : '0',
                                },
                              }))
                            }
                            colorScheme="blue"
                          >
                            Connected
                          </Checkbox>
                        </Flex>
                      </Box>

                      {/* SIM Card */}
                      <Box
                        border="1px dashed"
                        borderColor="blue.200"
                        borderRadius="md"
                        p={4}
                      >
                        <Flex
                          align="center"
                          flexDirection="column"
                          alignItems="flex-start"
                          mb={2}
                        >
                          <Text fontWeight="semibold" fontSize="md">
                            SIM Card
                          </Text>
                          <Checkbox
                            isChecked={editDeviceSetup.sim.c_status === '1'}
                            onChange={(e) =>
                              setEditDeviceSetup((prev) => ({
                                ...prev,
                                sim: {
                                  ...prev.sim,
                                  c_status: e.target.checked ? '1' : '0',
                                },
                              }))
                            }
                            colorScheme="blue"
                          >
                            Connected
                          </Checkbox>
                        </Flex>

                        <Text fontSize="sm" color="gray.600" mb={1}>
                          SIM Card Provider
                        </Text>
                        <Select
                          placeholder="Select provider"
                          value={editDeviceSetup.sim.provider}
                          onChange={(e) =>
                            setEditDeviceSetup((prev) => ({
                              ...prev,
                              sim: {
                                ...prev.sim,
                                provider: e.target.value,
                              },
                            }))
                          }
                        >
                          <option value="Airtel">Airtel</option>
                          <option value="Jio">Jio</option>
                          <option value="VI">VI</option>
                          <option value="BSNL">BSNL</option>
                        </Select>
                      </Box>
                    </Grid>
                  </Box>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>

          <ModalFooter
            bg={useColorModeValue('gray.50', 'gray.800')}
            borderTop="1px solid"
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            py={5}
            px={6}
            justifyContent="space-between"
            roundedBottom="xl"
          >
            <Button
              variant="ghost"
              colorScheme="red"
              fontWeight="medium"
              borderRadius="md"
              _hover={{ bg: useColorModeValue('red.50', 'red.900') }}
              onClick={onEditClose}
            >
              Cancel
            </Button>
            <Button
              bg="rgba(0, 106, 184, 1)"
              color="white"
              borderRadius="md"
              shadow="sm"
              _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
              onClick={handleSave}
              isLoading={loading}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Devices;
